export default "__VITE_ASSET__CNykbsi3__"